import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";

export const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleRedirect = () => {
    navigate("/payments");
  };

  return (
    <div className="max-w-4xl mx-auto h-full flex flex-col items-center justify-center">
      <div className="text-center">
        <h1 className="text-8xl" data-test-id="not-found-code">
          404
        </h1>
        <h2 className="text-6xl" data-test-id="not-found-title">
          {t("notFound_title")}
        </h2>
      </div>
      <div className="my-6 text-muted-foreground">
        <p className="leading-relaxed" data-test-id="not-found-description">
          {t("notFound_description")}
        </p>
      </div>
      <div className="mt-4">
        <Button
          size="lg"
          onClick={handleRedirect}
          data-test-id="not-found-button"
        >
          {t("home_claimButtonTitle")}
        </Button>
      </div>
    </div>
  );
};
